import { graphql } from 'relay-runtime';

export const InsertUserAction = graphql`
  mutation UserActionMutation($input: InsertUserActionInput!) {
    insertUserAction(input: $input) {
      userActionNode {
        id
        actionType {
          id
          name
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const getLastUserAction = graphql`
  query UserActionLastActionQuery($id: ID!, $action: [ID!]) {
    allUserActions(first: 1, filter: { userId: $id, actionTypeId: $action }, order: [{ timeStamp: DESC }]) {
      nodes {
        id
        timeStamp
        actionType {
          id
          name
        }
      }
    }
  }
`;

// `class` matters for the hide-diagnostic-widget action (type 22): a teacher hides the
// widget one class at a time, so each action carries the class it applies to, while a
// site admin's action carries none and hides it across all of their filters. There is no
// classId filter on allUserActions, so the caller matches the active filter client-side.
export const getWidgetUserAction = graphql`
  query UserActionWidgetActionQuery($id: ID!, $action: [ID!]) {
    allUserActions(filter: { userId: $id, actionTypeId: $action }, order: [{ timeStamp: DESC }]) {
      nodes {
        id
        timeStamp
        actionType {
          id
          name
        }
        class {
          id
        }
      }
    }
  }
`;
